import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { ProductClassSelect } from 'adminDashboard/benefitDetails/common/productClassSelect'
import { Formik } from 'formik'
import * as Yup from 'yup'

import { SetRenewalClassTitleRequest, setRenewalClassTitle } from 'core'

import { useCommandRequestV2 } from 'common/hooks'

const StateCheckBoxValue = -1

const SetIchraRenewalClassTitle = (props) => {
  const { t: translate } = useTranslation()
  const { bindSubmitFormHandler } = props
  const { sendCommand: sendSaveProductClass } = useCommandRequestV2((request: SetRenewalClassTitleRequest) =>
    setRenewalClassTitle(request),
  )

  const onSubmit = async (values: { classTypeIds: number[]; stateId: string }) => {
    const payload = {
      productClassId: props.state.productClassId,
      classTypeIds: values.classTypeIds,
      stateId: values.stateId,
    }
    const result = await sendSaveProductClass(payload)

    if (result.completed) {
      props.goNext()
    } else {
      props.setIsSubmiting(false)
    }
  }

  const [initialValues] = useState<{ classTypeIds: number[]; stateId: string }>({
    classTypeIds: props.state.classTypeIds ?? [],
    stateId: props.state.stateId,
  })

  return (
    <Formik
      enableReinitialize={true}
      validationSchema={formValidator(translate)}
      initialValues={initialValues}
      onSubmit={onSubmit}
      validate={(values) => {
        const isValid: boolean = formValidator(translate).isValidSync(values)
        props.setHasDirtyData(isValid)
        props.setIsFormValid(isValid)
        return {}
      }}
      validateOnChange={true}
      validateOnMount
    >
      {(formik) => {
        const { handleSubmit, submitForm } = formik
        bindSubmitFormHandler(submitForm)
        return (
          <div>
            <ProductClassSelect isBorderedButton isDisabled={props.editing} />
          </div>
        )
      }}
    </Formik>
  )
}

const formValidator = (translate: any) =>
  Yup.object({
    classTypeIds: Yup.array().required(translate('required')),
    stateId: Yup.string()
      .nullable()
      .when('classTypeIds', {
        is: (classTypeIds: number[]) => classTypeIds.includes(StateCheckBoxValue),
        then: Yup.string().required(translate('required')),
      }),
  })

export default SetIchraRenewalClassTitle
